import UUID from 'uuid';
import URI from 'urijs';
import { ISunnyRequestBuilderConstructor, SunnyRequestBuilder } from '@/models/Common/SunnyRequestBuilder';
import { IRequestWrap } from '@/server/IServer';

export abstract class CxJourneyAPIRequestBuilder extends SunnyRequestBuilder {
  static fromReq<T extends SunnyRequestBuilder>(this: ISunnyRequestBuilderConstructor<T>, req: IRequestWrap): T {
    if (!req || !req.config) {
      return new this();
    }

    const device = req.ua.getDevice();
    return new this({
      accessToken: req.config.CxJourneyAPIAccessToken,
      baseURI: this.getBaseURIFromReq(req),
      cgntId: req.cookies['cgntId'] || req.sunnyMeta['cgntId'],
      clientIP: (req.headers['x-forwarded-for'] as string) || req.connection.remoteAddress,
      platform: device.type === 'mobile' || device.type === 'tablet' ? 'MWeb' : 'Web',
      userAgent: req.ua.getUA(),
      ywt: req.session.getYWT(),
      testProduct: req.session.getSettings?.().testProduct,
      traceID: (req.headers['X-Trace-Id'] as string) || UUID.v4(),
      expGroups: req.serviceConfig?.serverExpGroups ?? '',
    });
  }

  static getBaseURIFromReq<T extends SunnyRequestBuilder>(
    this: ISunnyRequestBuilderConstructor<T>,
    req: IRequestWrap,
  ): URI {
    return req.config.CxJourneyAPI;
  }

  protected getAPIEndpoint(path: string): string {
    const baseURI = this.baseURI.href();
    return baseURI ? `${baseURI}${path}` : `${baseURI}/api/v1${path}`;
  }
}
